<template>
  <div>
    <breadcrumbs :back="[{text:'Bundles',to:{name:'InventoryBundles'}}]" :home="name"/>

    <purtrak-table name="bundletransactions" objectType="bundle transactions" :defaultColumns="defaultColumns" :headers="headers" ref="table"
                   :listEndPoint="getListData" fields="" totalField=""
                   :listFilters="listFilters"
                   @dblclick="transaction => view(transaction)"
                   :title="name"
                   :print-info="{pageSize:'landscape',
                                 subTitle:[filters.from?dateDisplay:'']}"
                   :download-endpoint="exportListData">
      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.from=null;filters.to=null">
          <v-list-item>
            <date-range :from.sync="filters.from" :to.sync="filters.to" v-model="dateDisplay" option="All" allow-all/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.from!=null" close small class="ml-1" @click:close="filters.from=null;filters.to=null">{{dateDisplay}}</v-chip>
        </template>
      </template>
      <template v-slot:item.date="{value}">
        {{value | formatDateTime}}
      </template>
      <template v-slot:item.description="{item,printing}">
        {{item.description}}
        <div v-if="!printing" class="text-caption">{{item.comments}}</div>
      </template>
      <template v-slot:item.value="{value}">
        {{value | currency}}
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="150" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Transaction operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="view(item)"><v-list-item-title>Details</v-list-item-title></v-list-item>
            <v-list-item v-if="audit" :to="{name:'Audit',query:{entityId:item.refId}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
            <template v-if="!readOnly">
              <v-divider/>
              <v-list-item @click="transaction=item;showDelete=true"><v-list-item-title>Delete transaction</v-list-item-title></v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" name="this transaction" @delete="performDeleteTransaction"/>
  </div>
</template>

<script>

export default {
  name: 'InventoryBundlessTransactions',
  props: {
    bundleId: {type:String, required:true}
  },
  data() {
    return {
      name: '',
      filters: {
        from: null,
        to: null,
      },
      dateDisplay: '',
      showDelete: false,
      defaultColumns: [{ value: 'date', visible:true},
                       { value: 'description', visible:true},
                       { value: 'comments', visible:false},
                       { value: 'value', visible:false},
                       { value: 'quantity', visible:true}],
      headers: [{ text: 'DATE', value: 'date', width:'15%',sortable:true},
                { text: 'ACTIVITY', value: 'description', width:'30%',sortable:false},
                { text: 'COMMENTS', value: 'comments', width:'30%',sortable:false},
                { text: 'QUANTITY', value: 'quantity', width:'15%',sortable:true,align:'right'},
                { text: 'VALUE', value: 'value', width:'15%',sortable:true,align:'right',omit:() => !this.values}]
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    values() {
      return this.company.permissions.includes('values');
    },
    readOnly() {
      return !this.company.permissions.includes('production.write');
    },
    audit() {
      return this.company.allowAudit && this.company.permissions.includes('audit');
    },
    listFilters() {
      const filters = [];
      if (this.filters.from)
        filters.push({field:'date', comparator:'ge', value:`${this.filters.from} 00:00:00`});
      if (this.filters.to)
        filters.push({field:'date', comparator:'le', value:`${this.filters.to} 23:59:59`});
      return filters;
    }
  },
  methods: {
    async getListData(after, cursor, pageSize, filters, parameters, options) {
      const results = await this.$apiCall(`query InventoryBundlessTransactions($id:ID!, $after: String, $first:Int, $before: String, $last: Int, $filters:[FilterInput], $sortKey: String, $reverse: Boolean, $parameters: [ParameterInput]) {
                                              bundle(id:$id) {
                                                name
                                                transactions(first:$first, after:$after, last:$last, before:$before, filters:$filters, sortKey:$sortKey, reverse:$reverse, parameters:$parameters) {
                                                  totalCount
                                                  pageInfo {
                                                    hasPreviousPage
                                                    hasNextPage
                                                    startCursor
                                                    endCursor
                                                  }
                                                  edges {
                                                    cursor
                                                    node {
                                                      id,date,refId,description,comments,quantity,value
                                                    }
                                                  }
                                                }
                                              }
                                            }`,
                                           {id:this.bundleId,
                                            after:after?cursor:null, first:after?pageSize:null,
                                            before:!after?cursor:null, last:!after?pageSize:null,
                                            filters, parameters,
                                            sortKey:options.sortBy[0], reverse:options.sortDesc[0]});

      const bundle = results.data.bundle;
      this.name = `${bundle.name}: Transactions`;
      return bundle.transactions;
    },

    async exportListData(filters, parameters, options) {
      const results = await this.$apiCall(`query InventoryBundlessTransactions($id:ID!, $filters:[FilterInput], $sortKey: String, $reverse: Boolean, $parameters: [ParameterInput]) {
                                              bundle(id:$id) {
                                                transactionsExportCSV(filters:$filters, sortKey:$sortKey, reverse:$reverse, parameters:$parameters)
                                              }
                                            }`,
                                          {id:this.bundleId,
                                          filters, parameters,
                                           sortKey:options.sortBy[0], reverse:options.sortDesc[0]});
      if (!results.error)
        return results.data.bundle.transactionsExportCSV;
    },
    view(item) {
      this.$router.push({name:'SalesShipmentsEdit',params:{shipmentId:item.refId}})
    },
    async performDeleteTransaction() {
      this.loading = true;
      const results = await this.$apiCall(`mutation InventoryBundlessTransactions($id: ID!) {
                                             objectDelete(id:$id)
                                           }`,
                                          {id:this.transaction.refId});
      this.loading = false;
      if (!results.error) {
        this.showDelete = false;
        this.$refs.table?.buildList();
        this.$store.commit('setError', {type:'success',message:`Deleted ${this.transaction.description} transaction`});
      }
    }
  }
}
</script>